/**
 * Message keys and image descriptors shared by the two public tenant pages.
 *
 * The landing page and the About page draw on the same `tenantPublic` namespace
 * — the hero standfirst *is* the first biography paragraph — so the orders live
 * here once rather than being re-typed (and drifting) in two components.
 *
 * Every string these name is in both messages/en.json and messages/hi.json; the
 * biography paragraphs are verbatim from the tenant's own copy, so nothing here
 * may be paraphrased in passing.
 */

/** Rendered in order as the full biography on the About page. */
export const BIOGRAPHY_KEYS = [
  "bioCredentials",
  "bioNotFear",
  "bioAnalysis",
  "bioApproach",
  "bioPeople",
  "bioBelief",
  "bioVision",
] as const;

/** The consultation areas, exactly as the biography lists them. */
export const GUIDANCE_KEYS = [
  "guidanceCareer",
  "guidanceBusiness",
  "guidanceRelationships",
  "guidanceMarriage",
  "guidanceFinances",
  "guidanceFamily",
  "guidanceGrowth",
  "guidanceDecisions",
] as const;

export const SPECIALISM_KEYS = [
  "specialismVedic",
  "specialismParashari",
  "specialismJaimini",
  "specialismHoroscope",
] as const;

/**
 * Intrinsic dimensions are carried alongside the path so every <img> can reserve
 * its box and the page does not reflow as the photographs arrive.
 */
export const INSTRUCTOR_IMAGES = {
  /** Landing hero — seated, hands folded. */
  portrait: { src: "/tenants/astromania/ankit-portrait.jpg", width: 880, height: 1100 },
  /** About page — formal, direct gaze. */
  profile: { src: "/tenants/astromania/ankit-profile.jpg", width: 880, height: 880 },
  /** Teaching approach — open hands, mid-explanation. */
  teaching: { src: "/tenants/astromania/ankit-teaching.jpg", width: 1500, height: 1000 },
  /** Philosophy quote — contemplative. */
  reflecting: { src: "/tenants/astromania/ankit-reflecting.jpg", width: 1500, height: 1000 },
} as const;
